import Axios from "axios";
import Url from "app/shared/constants/Url";
const FetchWorkingDays = async () => {
  let URL = Url.workingDay;
  let userId = localStorage.getItem("userId");
  let token = localStorage.getItem("springToken");
  const requestParams = {
    auth_key: token,
    user_id: userId,
  };

  try {
    const response = await Axios.get(`${URL}`, {
      params: requestParams,
      headers: {
        accept: "application/json",
      },
    });
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error(
      "Error fetching days",
      error.response?.data || error.message
    );
    throw error;
  }
};

export default FetchWorkingDays;
